import Modal from './Modal.tsx';
import ModalTitle from './ModalTitle.tsx';

const isModalClosedIntentionally = (role?: string) =>
  role === 'gesture' || role === 'closeButton' || role === 'backdrop';

export { Modal, ModalTitle, isModalClosedIntentionally };
